import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 *
 * @returns {모달 안내 문구가 가운데에 있는 텍스트 - 배포 모달}
 */

interface IProps {
  children: string | JSX.Element;
}
const DeployModalText: React.FC<IProps> = ({ children }) => {
  return <Text>{children}</Text>;
};

export default DeployModalText;

const Text = styled.p`
  font-size: ${theme.fontSizes.lg};
  span {
    font-size: ${theme.fontSizes.lg};
    font-weight: 700;
  }
`;
